import React from "react";

const SelectField = ({label, formik, name, disabled = false, options, onChange, elementClasses}) => {

    const {errors, touched, values} = formik;

    return <div className="sl-width-100 sl-text-left sl-flex sl-flex-col">
                                <span
                                    className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 "
                                    dangerouslySetInnerHTML={{__html: label}}/>
        <div
            className={`sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex sl-relative
            ${touched[name] && errors[name] ? 'sl-border-1 sl-border-solid sl-border-error-300 ' : ''}
            `}>
            <select
                disabled={disabled}
                value={values[name]}
                name={name}
                onChange={(e) => onChange(e.target.value)}
                className={`sl-input sl-border-none sl-rounded-lg sl-font sl-text-md sl-font sl-font-normal sl-text-md sl-m-0 sl-h-11 sl-w-fill-available sl-pl-2 sl-pr-8 ${elementClasses}`}
            >
                <option value={null}>All products</option>
                {options.map((option, index) => {
                    return <option key={index} value={option.value}>{option.name}</option>
                })}
            </select>

        </div>
        {touched[name] &&
            <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors[name]}</span>}
    </div>

}

export default SelectField;
